import React, {useState, useEffect, useContext } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../css/hotelCss.css';
import {MTNAPI_Transfer_Collections_To_Disbursments } from './Modal_TransferFromCollectionsToDisbursments';

export function View_MTNAPI(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [addToCollectionsModal, setAddToCollectionsModal] = useState(false);
    let [addToDisbursmentsModal, setAddToDisbursmentsModal] = useState(false);

    let [collections_balance, setCollections_balance] = useState(null)
    let [disbursments_balance, setDisbursments_balance] = useState(null)

    useEffect(() => {

        if(props.openModal == true)
        {


            //const customerPayAmount = parseFloat(event[5]).toFixed(2);
           // const payCurrency = 'GHS';
            //const payExternalId = '';
            //const payPartyId = event[3].replace(/^0+/, '');
            //const payPayerMessage = event[7] + " " + event[8] + " Momo Payment";
            //const payPayeeNote = "Bluefin Hotel Invoice";

            const apiuser = "824b5de8-0af9-4757-939b-f50992a0427f";
            const apikey = "e288a3938db14c8c9dfe3543427a141e";
            const concatenatedString = `${apiuser}:${apikey}`;
            const base64EncodedString = window.btoa(concatenatedString);

            fetch(baseURL+'mtnapi/collection/token/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Basic '+ base64EncodedString,
                    'x-target-environment': 'mtnghana',
                    'ocp-apim-subscription-key': 'c4f861935bb543cbba9f3762cf13fd9e',
                    'session_id': sessionID,
                    'user': acctID,
                    'balance': 'true',
                },
            })
            .then(res => res.json())
            .then(res => {

                            fetch(baseURL+'mtnapi/collection/v1_0/account/balance', {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': 'Bearer '+ res.access_token.toString(),
                                    'x-target-environment': 'mtnghana',
                                    'ocp-apim-subscription-key': 'c4f861935bb543cbba9f3762cf13fd9e',
                                    'session_id': sessionID,
                                    'user': acctID,
                                },
                
                
                            })
                            .then(res => res.json())
                            .then(res => {
                
                                alert(res);
                                setCollections_balance(res.availableBalance);


                                        const apiuser2 = "0a8356fc-ce44-4436-a976-68a954d94094";
                                        const apikey2 = "9070094e5ece4fabb351a0e282043cee";
                                        const concatenatedString2 = `${apiuser2}:${apikey2}`;
                                        const base64EncodedString2 = window.btoa(concatenatedString2);

                                        fetch(baseURL+'mtnapi2/disbursement/token/', {
                                            method: 'POST',
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'authorization': 'Basic '+ base64EncodedString2,
                                                'x-target-environment': 'mtnghana',
                                                'ocp-apim-subscription-key': 'ff1585eb2f8a41d29771cca4238c02d3',
                                                'session_id': sessionID,
                                                'user': acctID,
                                                'balance': 'true',
                                            },
                                        })
                                        .then(res => res.json())
                                        .then(res => {

                                                        fetch(baseURL+'mtnapi2/disbursement/v1_0/account/balance', {
                                                            method: 'GET',
                                                            headers: {
                                                                'Content-Type': 'application/json',
                                                                'Authorization': 'Bearer '+ res.access_token.toString(),
                                                                'x-target-environment': 'mtnghana',
                                                                'ocp-apim-subscription-key': 'ff1585eb2f8a41d29771cca4238c02d3',
                                                                'session_id': sessionID,
                                                                'user': acctID,
                                                            },
                                            
                                            
                                                        })
                                                        .then(res => res.json())
                                                        .then(res => {
                                            
                                                            alert(res);
                                                            setDisbursments_balance(res.availableBalance);
                                            
                                                        })

                                        })
                
                            })

            })
        }
    }, [props.openModal]);



    /*useEffect(() => {

        if(props.openModal == true)
        {

            const apiuser = "28fd26ad-0cda-49a2-ad90-15083276a26a";
            const apikey = "218c665182e447538d0e6ac6f36ad3b4";
            const concatenatedString = `${apiuser}:${apikey}`;
            const base64EncodedString = window.btoa(concatenatedString);

            fetch(baseURL+'mtnapi/disbursement/token/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Basic '+ base64EncodedString,
                    'x-target-environment': 'mtnghana',
                    'ocp-apim-subscription-key': 'ff1585eb2f8a41d29771cca4238c02d3',
                    'session_id': sessionID,
                    'user': acctID,
                    'balance': true,
                },
            })
            .then(res => res.json())
            .then(res => {

                            fetch(baseURL+'mtnapi/disbursement/v1_0/account/balance', {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': 'Bearer '+ res.access_token.toString(),
                                    'x-target-environment': 'mtnghana',
                                    'ocp-apim-subscription-key': 'c4f861935bb543cbba9f3762cf13fd9e',
                                    'session_id': sessionID,
                                    'user': acctID,
                                },
                
                
                            })
                            .then(res => res.json())
                            .then(res => {
                
                                alert(res);
                                setDisbursments_balance(res.availableBalance);
                
                            })

            })
        }
    }, [props.openModal]);*/




    function closeModalHandler() {

        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>

            <IonGrid class='appGridContent'>
                <IonRow>
                    <IonCol size='6'>
                        <h3>Collections</h3>
                    </IonCol>
                    <IonCol size='6'>
                        <h3>Disbursments</h3>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol> <h3>{collections_balance}</h3></IonCol>
                    <IonCol> <h3>{disbursments_balance}</h3></IonCol>
                </IonRow>
                <IonRow>
                    <IonCol> <IonButton onClick={() => setAddToCollectionsModal(true)}>Add</IonButton></IonCol>
                    <IonCol> <IonButton onClick={() => setAddToDisbursmentsModal(true)}>Add</IonButton></IonCol>
                </IonRow>
            </IonGrid>
    

        {/*<MTNAPI_Add_To_Collections  openModal={ addToCollectionsModal } closeModal={() => setAddToCollectionsModal(false)}></MTNAPI_Add_To_Collections>*/}



    <MTNAPI_Transfer_Collections_To_Disbursments  openModal={ addToDisbursmentsModal } closeModal={() => setAddToDisbursmentsModal(false)}></MTNAPI_Transfer_Collections_To_Disbursments>


        <IonGrid class='modal_footer_button_center'>
            <IonButton onClick={closeModalHandler}> Close </IonButton>
        </IonGrid>
    </IonModal>) : null}
    </React.Fragment>
    )
}